'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _reports = require('./reports.component');

var _reports2 = _interopRequireDefault(_reports);

var _executivesummary = require('../../common/reports/executivesummary/executivesummary');

var _executivesummary2 = _interopRequireDefault(_executivesummary);

var _episodelist = require('../../common/reports/episodelist/episodelist');

var _episodelist2 = _interopRequireDefault(_episodelist);

var _changespercoder = require('../../common/reports/changespercoder/changespercoder');

var _changespercoder2 = _interopRequireDefault(_changespercoder);

var _commondrgchanges = require('../../common/reports/commondrgchanges/commondrgchanges');

var _commondrgchanges2 = _interopRequireDefault(_commondrgchanges);

var _commonicdchanges = require('../../common/reports/commonicdchanges/commonicdchanges');

var _commonicdchanges2 = _interopRequireDefault(_commonicdchanges);

var _commonicdchangesbydrg = require('../../common/reports/commonicdchangesbydrg/commonicdchangesbydrg');

var _commonicdchangesbydrg2 = _interopRequireDefault(_commonicdchangesbydrg);

var _commonchangedtodrg = require('../../common/reports/commonchangedtodrg/commonchangedtodrg');

var _commonchangedtodrg2 = _interopRequireDefault(_commonchangedtodrg);

var _awaitingreview = require('../../common/reports/awaitingreview/awaitingreview');

var _awaitingreview2 = _interopRequireDefault(_awaitingreview);

var _queries = require('../../common/reports/queries/queries');

var _queries2 = _interopRequireDefault(_queries);

var _querychanges = require('../../common/reports/querychanges/querychanges');

var _querychanges2 = _interopRequireDefault(_querychanges);

var _sentqueries = require('../../common/reports/sentqueries/sentqueries');

var _sentqueries2 = _interopRequireDefault(_sentqueries);

var _mechvent = require('../../common/reports/mechvent/mechvent');

var _mechvent2 = _interopRequireDefault(_mechvent);

var _atsi = require('../../common/reports/atsi/atsi');

var _atsi2 = _interopRequireDefault(_atsi);

var _unitaudit = require('../../common/reports/unitaudit/unitaudit');

var _unitaudit2 = _interopRequireDefault(_unitaudit);

var _totalaudit = require('../../common/reports/totalaudit/totalaudit');

var _totalaudit2 = _interopRequireDefault(_totalaudit);

var _auditsbymonth = require('../../common/reports/auditsbymonth/auditsbymonth');

var _auditsbymonth2 = _interopRequireDefault(_auditsbymonth);

var _auditprogress = require('../../common/reports/auditprogress/auditprogress');

var _auditprogress2 = _interopRequireDefault(_auditprogress);

var _codedmedicalrecords = require('../../common/reports/codedmedicalrecords/codedmedicalrecords');

var _codedmedicalrecords2 = _interopRequireDefault(_codedmedicalrecords);

var _coderreviewed = require('../../common/reports/coderreviewed/coderreviewed');

var _coderreviewed2 = _interopRequireDefault(_coderreviewed);

var _targetdrgs = require('../../common/reports/targetdrgs/targetdrgs');

var _targetdrgs2 = _interopRequireDefault(_targetdrgs);

var _picq = require('../../common/reports/picq/picq');

var _picq2 = _interopRequireDefault(_picq);

var _auditresultsummary = require('../../common/reports/auditresultsummary/auditresultsummary');

var _auditresultsummary2 = _interopRequireDefault(_auditresultsummary);

var _incompletedocumentation = require('../../common/reports/incompletedocumentation/incompletedocumentation');

var _incompletedocumentation2 = _interopRequireDefault(_incompletedocumentation);

var _codingactivity = require('../../common/reports/codingactivity/codingactivity');

var _codingactivity2 = _interopRequireDefault(_codingactivity);

var _readmissions = require('../../common/reports/readmissions/readmissions');

var _readmissions2 = _interopRequireDefault(_readmissions);

var _episodechangereport = require('../../common/reports/episodechangereport/episodechangereport');

var _episodechangereport2 = _interopRequireDefault(_episodechangereport);

var _auditprogramdrgchanges = require('../../common/reports/auditprogramdrgchanges/auditprogramdrgchanges');

var _auditprogramdrgchanges2 = _interopRequireDefault(_auditprogramdrgchanges);

var _auditprogramresults = require('../../common/reports/auditprogramresults/auditprogramresults');

var _auditprogramresults2 = _interopRequireDefault(_auditprogramresults);

var _executivesummary3 = require('../../common/reports/executivesummary_poc/executivesummary.poc');

var _executivesummary4 = _interopRequireDefault(_executivesummary3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportsModule = _angular2.default.module('reports', [_angularUiRouter2.default, _executivesummary2.default.name, _episodelist2.default.name, _changespercoder2.default.name, _commondrgchanges2.default.name, _commonicdchanges2.default.name, _commonicdchangesbydrg2.default.name, _commonchangedtodrg2.default.name, _queries2.default.name, _awaitingreview2.default.name, _querychanges2.default.name, _sentqueries2.default.name, _mechvent2.default.name, _atsi2.default.name, _unitaudit2.default.name, _totalaudit2.default.name, _auditsbymonth2.default.name, _auditprogress2.default.name, _codedmedicalrecords2.default.name, _coderreviewed2.default.name, _targetdrgs2.default.name, _picq2.default.name, _auditresultsummary2.default.name, _incompletedocumentation2.default.name, _codingactivity2.default.name, _readmissions2.default.name, _episodechangereport2.default.name, _auditprogramdrgchanges2.default.name, _auditprogramresults2.default.name, _executivesummary4.default.name]).config(function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider.state('reports', {
    url: '/reports',
    template: '<reports></reports>',
    authenticate: true
  }).state('reports.episodelist', {
    url: '/episodelist',
    template: '<episodelist></episodelist>',
    authenticate: true
  }).state('reports.changespercoder', {
    url: '/changespercoder',
    template: '<changespercoder></changespercoder>',
    authenticate: true
  }).state('reports.commondrgchanges', {
    url: '/commondrgchanges',
    template: '<commondrgchanges></commondrgchanges>',
    authenticate: true
  }).state('reports.commonicdchanges', {
    url: '/commonicdchanges',
    template: '<commonicdchanges></commonicdchanges>',
    authenticate: true
  }).state('reports.commonicdchangesbydrg', {
    url: '/commonicdchangesbydrg',
    template: '<commonicdchangesbydrg></commonicdchangesbydrg>',
    authenticate: true,
    params: {
      drg: {
        value: '0',
        squash: false
      },
      specialty: {
        value: '0',
        squash: false
      },
      startDate: {
        value: '0',
        squash: false
      },
      endDate: {
        value: '0',
        squash: false
      }
    }
  }).state('reports.executivesummary', {
    url: '/executive-summary',
    template: '<executivesummary></executivesummary>',
    authenticate: true
  }).state('reports.executivesummary-auditing', {
    url: '/executive-summary-auditing',
    template: '<executivesummarypoc></executivesummarypoc>',
    authenticate: true
  }).state('reports.commonchangedtodrg', {
    url: '/commonchangedtodrg',
    template: '<commonchangedtodrg></commonchangedtodrg>',
    authenticate: true
  }).state('reports.awaitingreview', {
    url: '/awaitingreview',
    template: '<awaitingreview></awaitingreview>',
    authenticate: true
  }).state('reports.queries', {
    url: '/queries',
    template: '<queries></queries>',
    authenticate: true
  }).state('reports.querychanges', {
    url: '/querychanges',
    template: '<querychanges></querychanges>',
    authenticate: true
  }).state('reports.mechvent', {
    url: '/mechanical-ventilation',
    template: '<mechvent></mechvent>',
    authenticate: true
  }).state('reports.atsi', {
    url: '/atsi',
    template: '<atsi></atsi>',
    authenticate: true
  }).state('reports.unitaudit', {
    url: '/unit-audit',
    template: '<unitaudit></unitaudit>',
    authenticate: true
  }).state('reports.totalaudit', {
    url: '/total-audit',
    template: '<totalaudit></totalaudit>',
    authenticate: true
  }).state('reports.auditsbymonth', {
    url: '/audits-by-month',
    template: '<auditsbymonth></auditsbymonth>',
    authenticate: true
  }).state('reports.auditprogress', {
    url: '/audit-progress',
    template: '<auditprogress></auditprogress>',
    authenticate: true
  }).state('reports.codedmedicalrecords', {
    url: '/coded-medical-records',
    template: '<codedmedicalrecords></codedmedicalrecords>',
    authenticate: true
  }).state('reports.codingreview', {
    url: '/codingreview',
    template: '<coderreviewed></coderreviewed>',
    authenticate: true
  }).state('reports.targetdrgs', {
    url: '/target-drgs',
    template: '<targetdrgs></targetdrgs>',
    authenticate: true
  }).state('reports.picq', {
    url: '/picq',
    template: '<picq></picq>',
    authenticate: true
  }).state('reports.auditresultsummary', {
    url: '/audit-result-summary',
    template: '<auditresultsummary></auditresultsummary>',
    authenticate: true
  }).state('reports.incompletedocumentation', {
    url: '/incompletedocumentation',
    template: '<incompletedocumentation></incompletedocumentation>',
    authenticate: true
  }).state('reports.codingactivity', {
    url: '/coding-activity',
    template: '<codingactivity></codingactivity>',
    authenticate: true
  }).state('reports.readmissions', {
    url: '/readmissions',
    template: '<readmissions></readmissions>',
    authenticate: true
  }).state('reports.episodechangereport', {
    url: '/episodechangereport',
    template: '<episodechangereport></episodechangereport>',
    authenticate: true
  }).state('reports.sentqueries', {
    url: '/sentqueries',
    template: '<sentqueries></sentqueries>',
    authenticate: true
  }).state('reports.auditprogramdrgchanges', {
    url: '/audited-medical-drg-records',
    template: '<auditprogramdrgchanges></auditprogramdrgchanges>',
    authenticate: true
  }).state('reports.auditprogramresults', {
    url: '/audit-program-results',
    template: '<auditprogramresults></auditprogramresults>',
    authenticate: true
  });
}).component('reports', _reports2.default);

// Reports
exports.default = reportsModule;


// WEBPACK FOOTER //
// ./client/app/components/reports/reports.js